import request from '@/utils/requestDeploy'

export function getBranchs(query) {
  return request({
    url: '/GitHub/GetBranchs',
    method: 'get',
    params: query,
  })
}

export function getBranch(query) {
  return request({
    url: '/GitHub/GetBranch',
    method: 'get',
    params: query,
  })
}

export function saveTaskData(data) {
  return request({
    url: '/DeployTask/Save',
    method: 'post',
    data,
  })
}

export function getDeployTaskList(data) {
  return request({
    url: '/DeployTask/GetDeployTaskList',
    method: 'post',
    data,
  })
}

export function doUpdated(data) {
  return request({
    url: '/DeployTask/Updated',
    method: 'post',
    data,
  })
}

export function GetAllServicesInRepository(query) {
  return request({
    url: '/DeployTask/GetAllServicesInRepository',
    method: 'get',
    params: query,
  })
}
